<template>
  <div class="point-main">
    <!--双倍积分功能目前没有使用-->
    <div class="double-point" v-if="isShowDoublePoint">
      <div class="">
        <div class="point-icon">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/point-iconPc.png" alt="">
        </div>
      </div>
      <div>双倍积分</div>
    </div>
    <div class="point-content">
      <div class="point-icon" v-if="showPointIcon">
        <img v-show="!isShowDoublePoint" src="https://resource.rcclchina.com.cn/wechatMiniProgram/point-iconPc.png" alt="">
      </div>
      <div :class="['pointAndIcon', {'isPointIcon': showPointIcon}]">
        <div class="point-text">
          <template v-if="bookingIntegralsStatue == 1">预计获得<span class="highlight-color">{{point}}积分</span></template>
          <template v-else-if="bookingIntegralsStatue == 2">该订单可在48小时内计算出预估积分</template>
          <img class="point-text__icon" src="https://resource.rcclchina.com.cn/wechatMiniProgram/question.png" alt="" @mouseenter="showPointPopup"
                @mouseleave="hidePointPopup" align="middle" />
          <div class="point-popup" v-if="isShowPointPopup">
            <div class="point-popup-content">
              积分可兑换现金礼品卡、限量皇家周边、大额船票立减券等，还可参与免费船票抽奖~
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isFinishSelfInfo" :class="['point-tips', {'isPointIcon': showPointIcon}]">（需会员本人预订且出行）</div>
    <div v-else :class="['point-tips is-pointer', {'isPointIcon': showPointIcon}]" @click="goToEditInfo">
      （请最晚于<span class="highlight-color">下船日前</span>至<span class="highlight-color">会员中心-完善信息</span>需会员本人预订且出行可获得积分）
    </div>
  </div>
</template>
<script>
export default {
  props: {
    point:{
      default: 0
    },
    isFinishSelfInfo:{
      type: Boolean,
      default: false
    },
    showPointIcon:{
      type: Boolean,
      default: false
    },
    isShowDoublePoint:{
      type: Boolean,
      default: false
    },
    bookingIntegralsStatue:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isShowPointPopup:false
    }
  },
  methods: {
    showPointPopup(){
      this.isShowPointPopup = true
    },
    hidePointPopup(){
      this.isShowPointPopup = false
    },
    goToEditInfo(){
      if(!this.isFinishSelfInfo){
        this.$router.push({
          path: '/Rccl.UserCenter/CustomerInfo/EditInfo'
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.point-main{
  position: relative;
  z-index: 9;
  line-height: 16px;
}
.double-point{
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: 6px;
  & .point-icon{
    width: 16px;
    height: 16px;
    line-height: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.point-content{
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: 6px;
  cursor: pointer;
  .pointAndIcon{
    //margin-top: 6px;
    &.isPointIcon {
      margin-top: 0;
    }
    .point-text{
      position: relative;
      display: inline-block;
      height: 16px;
      line-height: 16px;
      & .point-text__icon {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-top: -3px;
        margin-left: 3px;
      }
    }
  }
  & .point-icon{
    width: 16px;
    height: 16px;
    line-height: 51px;
    img{
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  & .point-questIcon{
    width: 14px;
    height: 14px;
    line-height: 1;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.point-popup{
  width: 306px;
  height: 160px;
  //background: url("https://resource.rcclchina.com.cn/wechatMiniProgram/point-popup-bg.png") no-repeat;
  background: url("https://resource.rcclchina.com.cn/member/point/pointPopupBg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  padding: 76px 18px 29px;
  font-size: 14px;
  left: -42px;
  bottom: 20px;
  cursor: pointer;
  z-index: 99;
  line-height: 22px;
  box-shadow: 6px -10px 10px 0px rgba(0, 0, 0, 0.2);
  & .point-popup-content{
    color: #5C5C5C;
    & span{
      color: #006AB6;
    }
  }
}
.point-popup-pay{
  width: 218px;
  height: 183px;
  background: url("https://resource.rcclchina.com.cn/wechatMiniProgram/point-popup-bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  padding: 72px 17px 31px;
  font-size: 14px;
  left: 72px;
  bottom: 35px;
  cursor: pointer;
  z-index: 99;
  line-height: 20px;
  box-shadow: 6px -10px 10px 0px rgba(0, 0, 0, 0.2);
  & .point-popup-content{
    color: #5C5C5C;
    & span{
      color: #006AB6;
    }
  }
}
.point-tips {
  font-size: 12px;
  margin-left: -3px;
  margin-top: 3px;
  cursor: default;
  color: #5C5C5C;
  &.is-pointer {
    cursor: pointer;
  }
  &.isPointIcon {
    margin-left: 20px;
  }
}
.highlight-color {
  color: #006AB6
}
</style>
